import script from "./UserFileDocModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserFileDocModal.vue?vue&type=script&setup=true&lang=ts"

import "./UserFileDocModal.vue?vue&type=style&index=0&id=76a4dc5c&scoped=true&lang=scss"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76a4dc5c"]])

export default __exports__